import React, { useReducer, useState } from "react";
import "./style.css";
import { useTranslation } from "react-i18next";
import { FormButton, FormInput } from "../../../components/form";
import { useDispatch, useSelector } from "react-redux";
import { deleteSchool } from "../../../api/schools";
import { setAlert } from "../../../redux/reducers/alert";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import { SearchInput } from "../../../components/form/searchInput";
import { BLUE_EIGHT, WHITE } from "../../../theme";

export const TableHeader = ({
  handleAdd,
  selectedIds,
  deleteCallback,
  searchValue,
}) => {
  const [{ search, searchError }, setData] = useReducer(
    (state, newState) => ({ ...state, ...newState }),
    {
      search: "",
      searchError: false,
    }
  );

  const [loading, setLoading] = useState(false);
  const { token } = useSelector((state) => state.user);
  const { role } = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const handleChange = (prop) => (event) => {
    searchValue(event.target.value);
    setData({
      [prop]: event.target.value,
      searchError: false,
    });
  };

  const showErrorAlert = (message) => {
    dispatch(
      setAlert({
        severity: "error",
        message,
        show: true,
      })
    );
  };

  const handleDelete = async () => {
    try {
      setLoading(true);
      await Promise.all(
        selectedIds.map(async (id) => {
          await deleteSchool(id, token);
        })
      );

      deleteCallback();
      setLoading(false);
    } catch (err) {
      setLoading(false);
      showErrorAlert(
        err.message || "Error in deleting school. Please try again"
      );
    }
  };

  return (
    <div className="table-header">
      <div style={{ width: 400, paddingLeft: 20 }}>
        <SearchInput
          disabled={role === "manager" || role === "readOnly" ? true : false}
          searchIcon={true}
          error={searchError}
          value={search}
          onChange={handleChange}
          label={t("text_search_by_school_id_or_school_name")}
          name="search"
          height={40}
        />
      </div>

      <div style={{ flex: 1, display: "flex", justifyContent: "flex-end" }}>
        <div style={{ paddingLeft: 20 }}>
          <FormButton
            height={40}
            width={"10vw"}
            borderTopRightRadius={15}
            borderTopLeftRadius={15}
            borderBottomLeftRadius={15}
            borderBottomRightRadius={15}
            borderColor={BLUE_EIGHT}
            titleColor={BLUE_EIGHT}
            hoverTitleColor={WHITE}
            hoverBorderColor={BLUE_EIGHT}
            backgroundColor={WHITE}
            hoverBackgroundColor={BLUE_EIGHT}
            title={t("text_add_school")}
            style={{ textTransform: "none", fontSize: "0.8vw", fontWeight: "700", padding: 0 }}
            onClickHandler={handleAdd}
            startIcon={<AddCircleIcon color="inherit" />}
            disabled={role === "manager" ? false : true}
          />
        </div>
      </div>
    </div>
  );
};
